import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function PrivateTripBanner() {
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          whileHover="hover"
          className="group w-full relative"
          data-testid="private-trip-banner"
        >
          <Link to="/private-trips" className="block text-left">
            <div className="relative bg-owt-forest text-owt-surface p-8 md:p-16 border border-owt-forest">
              <div className="grid md:grid-cols-12 gap-6 items-end">
                <div className="md:col-span-8">
                  <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-owt-sand/70 mb-4">
                    For you, only you
                  </div>
                  <h3 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight">
                    Want a private trip,
                    <br/>
                    <span className="text-owt-terracotta italic">just for you?</span>
                  </h3>
                  <p className="mt-4 text-owt-sand/80 max-w-md">
                    Tell us where and when — we'll design it around you.
                  </p>
                </div>
                <div className="md:col-span-4 flex md:justify-end">
                  <motion.div
                    variants={{ hover: { x: 10, y: -10 } }}
                    transition={{ duration: 0.5 }}
                    className="inline-flex items-center gap-3 border border-owt-surface/60 px-6 py-4"
                  >
                    <span className="font-mono text-[11px] tracking-[0.25em] uppercase">See private trips</span>
                    <ArrowUpRight className="w-5 h-5"/>
                  </motion.div>
                </div>
              </div>
              <div className="absolute right-6 top-6 hidden md:flex">
                <div className="stamp bg-owt-forest">Custom · V.I.P</div>
              </div>
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
